import { Api } from '../api';
import { account } from '../endpoints';
import { IFile } from '../file';
import type {
  AccountDetailsEntity,
  AccountEntity,
  ChangeCreditLimitResponse,
  CreditChangeParams,
  CreditLimitEntity,
  GetCreditPdfRequest,
  RequestEntity,
  SetAccountPartnerAccountNumberRequest,
  UploadCreditFormRequest,
} from './models';

export class AccountApi extends Api {
  static getAccountsByCustomer = (customerId: string, signal?: AbortSignal) =>
    this.get<AccountEntity[]>({ url: account.getCustomer(customerId), signal });

  static getAccountDetails = (accountCode: string, signal?: AbortSignal) =>
    this.get<AccountDetailsEntity>({ url: account.getAccountDetails(accountCode), signal });

  static getCreditLimit = (accountId: string, signal?: AbortSignal) =>
    this.get<CreditLimitEntity>({ url: account.getCreditLimit(accountId), signal });

  static changeCreditLimit = (searchParams: CreditChangeParams, signal?: AbortSignal) =>
    this.post<CreditChangeParams, ChangeCreditLimitResponse>({ url: account.postCreditLimit(), data: searchParams, signal });

  static getCreditLimitRequests = (accountId: string, signal?: AbortSignal) =>
    this.get<RequestEntity[]>({ url: account.getCreditLimitRequests(accountId), signal });

  static approveRequest = (requestId: string, signal?: AbortSignal) => this.post({ url: account.approveCreditLimitRequest(requestId), signal });

  static rejectRequest = (requestId: string, signal?: AbortSignal) => this.post({ url: account.rejectCreditLimitRequest(requestId), signal });

  static setPartnerAccountNumber = (request: SetAccountPartnerAccountNumberRequest, signal?: AbortSignal) =>
    this.post<SetAccountPartnerAccountNumberRequest>({ url: account.partnerAccountNumber(), data: request, signal });

  static getUploadedCreditPdf = (requestId: string, signal?: AbortSignal) =>
    this.get<IFile>({ url: account.getCreditLimitFile(requestId), headers: { Accept: 'application/pdf' }, signal });

  static uploadCreditForm = (request: UploadCreditFormRequest, signal?: AbortSignal) => {
    const formData = request.data.reduce((curData, file) => {
      curData.append('file', file);

      return curData;
    }, new FormData());

    return this.post<FormData>({
      url: account.uploadCreditLimitFile(request.requestId),
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    });
  };

  static getCreditPdf = (queryParams: GetCreditPdfRequest, signal?: AbortSignal) =>
    this.get<IFile>({
      url: account.getCreditPdf(),
      queryParams,
      headers: { Accept: 'application/pdf' },
      signal,
    });
}
